import { NOTE_VISIBILITY_AUTHOR_ONLY } from "note/constants"

let Note
export default Note = class Note extends (
  require("lib/static-shim").default(require("lib/utils/model").default)
) {
  defaults() {
    let defaults
    return (defaults = { visibility: NOTE_VISIBILITY_AUTHOR_ONLY })
  }

  url() {
    const sync_source_id = this.get("context") && this.get("context").step
    const contextStr =
      window.App.getStore("note").request.getContextStr(sync_source_id)
    return this.urlRoot(
      `api/private/note/${this.id ? `${this.id}/` : ""}?context=${contextStr}`
    )
  }
}
